import {
  asPercent,
  getCollateralAprMetrics,
  getDebtAprMetrics,
  getProtectedAprMetrics,
} from "@silo/utils";
import { cn } from "../../utils/class-names";
import { getDebtRewardsStateColor } from "./utils";
import { FireIcon } from "../../icons";
import {
  CollateralAprAsset,
  DebtAprAsset,
  Percent,
  ProtectedAprAsset,
} from "@silo/types";

export interface MarketCardCollateralProps {
  className?: string;
  asset: CollateralAprAsset;
  nativeRewardsSymbol: string;
}

export function MarketCardCollateral({
  className,
  asset,
  nativeRewardsSymbol,
}: MarketCardCollateralProps): JSX.Element {
  const { hasCollateralRewards, totalCollateralApr } = getCollateralAprMetrics(
    asset,
    nativeRewardsSymbol
  );

  return (
    <div
      className={cn(
        "font-mono text-sm font-medium text-white",
        hasCollateralRewards ? "text-amber-300" : "",
        className
      )}
    >
      {asPercent(totalCollateralApr)}
    </div>
  );
}

export interface MarketCardProtectedProps {
  className?: string;
  asset: ProtectedAprAsset;
  nativeRewardsSymbol: string;
  revenueApr: Percent;
}

export function MarketCardProtected({
  className,
  asset,
  nativeRewardsSymbol,
  revenueApr,
}: MarketCardProtectedProps): JSX.Element {
  const { totalProtectedApr, hasProtectedIncentives } = getProtectedAprMetrics(
    asset,
    nativeRewardsSymbol,
    revenueApr
  );

  return (
    <div
      className={cn(
        "font-mono text-sm font-medium text-white",
        hasProtectedIncentives ? "text-amber-300" : "",
        className
      )}
    >
      {asPercent(totalProtectedApr)}
    </div>
  );
}

export interface MarketCardDebtProps {
  className?: string;
  asset: DebtAprAsset;
  nativeRewardsSymbol: string;
}

export function MarketCardDebt({
  className,
  asset,
  nativeRewardsSymbol,
}: MarketCardDebtProps): JSX.Element {
  const { isDebtAprFixed } = asset;

  const { totalDebtApr, debtRewardsState, showFixedLabel } = getDebtAprMetrics(
    asset,
    nativeRewardsSymbol
  );

  return (
    <div
      className={cn(
        "flex items-center justify-end gap-1 font-mono text-sm font-medium text-white",
        className
      )}
    >
      <span
        className={cn(
          "flex flex-col items-end",
          isDebtAprFixed ? "text-amber-300" : "",
          getDebtRewardsStateColor(debtRewardsState)
        )}
      >
        <span>{asPercent(totalDebtApr)}</span>

        {showFixedLabel && <span className="font-sans">Fixed</span>}
      </span>

      {debtRewardsState === "netYield" && (
        <FireIcon className="w-4 h-4 text-green-400" />
      )}
    </div>
  );
}
